<template>
  <div class="content_box">
    <el-carousel indicator-position="outside">
      <el-carousel-item v-for="(item,index) in pictureList" :key="index" >
        <img style="width:100%;height:100%;border-radius: 8px;" :src="item.picture||item" alt  @click="pictureDetails(item.id)"/>
        <div class="black_none" v-if="item.title">{{item.title}}</div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props:['pictureList'],
  data() {
    return {
      
    }
  },
  created(){
    
  },
  methods:{
    pictureDetails(){
      
    }
  }
}
</script>

<style lang="less" scoped>
.content_box{
  .black_none {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 77px;
    line-height: 77px;
    background: url("../assets/images/black_none.png");
    font-size: 20px;
    color: #ffffff;
    text-align: center;
  }
  .el-carousel__indicators, .el-carousel__indicators--horizontal, .el-carousel__indicators--outside{
    // position: absolute;
    left: 35%;
    bottom: 0;
  }
  /deep/.el-carousel__container{
    height: 370px;
  }
  .el-carousel__item{
    border-radius: 8px;
  }
  .el-carousel__container{
    height: 338px!important;
    margin-top: 45px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/slideshow.vue